export const articles = [
  {
    slug: "dj-festa-di-paese-ticino",
    title: "DJ per Festa di Paese in Ticino | DJMAGIX",
    description:
      "DJ per feste di paese in Ticino: musica per tutte le generazioni, impianto per la piazza, prezzi chiari e consigli pratici per il comitato.",
    h1: "DJ per Festa di Paese in Ticino: la Guida per il Comitato",
    date: "2026-10-16",
    image: "/assets/gallery3.webp",
    excerpt:
      "Piazza piena fino a tarda notte: cosa serve davvero per la musica della festa di paese, dai permessi alla scaletta per tre generazioni.",
    blocks: [
      {
        text: "Le feste di paese sono la mia seconda casa. In 25 anni ho suonato in decine di piazze del Ticino, dal Mercoledì Grasso al palco estivo del quartiere. Una festa riuscita si riconosce da un dettaglio: a mezzanotte la pista è ancora piena. Ecco come ci arriviamo, passo per passo.",
      },
      {
        h2: "1. La piazza non è un club: potenza e copertura",
        text: "All'aperto il suono si disperde e i muri rimbalzano. Serve un impianto dimensionato sull'area reale della pista, non sul numero di biglietti. Io porto audio e luci propri fino a 1000 persone, con la consolle posizionata dove la musica arriva pulita e i vicini dormono il più possibile.",
      },
      {
        h2: "2. Una scaletta per tre generazioni",
        text: "Il segreto di una festa di paese è l'alternarsi dei momenti. Si parte morbidi durante la cena, si alza il ritmo con il revival anni 80/90 e la disco dance, e se la tradizione lo chiede c'è spazio anche per il ballo liscio. Bambini, genitori e nonni devono trovare il proprio brano: è il mio lavoro leggere la pista e dosare i generi.",
      },
      {
        h2: "3. Orari e permessi: il punto delicato",
        text: "Ogni Comune ha le sue regole su orari e volumi, soprattutto la domenica. Il mio consiglio: chiarite tutto con il Municipio settimane prima e avvisate il vicinato. Io gestisco i volumi in serata con gradualità, così la festa resta bella fino alla fine senza visite sgradite.",
      },
      {
        h2: "4. Quanto costa",
        text: "I pacchetti partono da CHF 150. Il prezzo finale dipende da ore di servizio, dimensione dell'impianto e trasferta. Il preventivo è gratuito, scritto e senza impegno: il comitato sa esattamente cosa riceve e cosa spende.",
      },
      {
        h2: "5. La checklist del comitato",
        text: "Sei nel comitato festeggiamenti? Ecco i controlli che consiglio prima di firmare con chiunque:",
        list: [
          "Attrezzatura propria, non noleggiata all'ultimo momento",
          "Piano B in caso di guasto o maltempo",
          "Incontro preventivo per scaletta e orari",
          "Preventivo scritto con ore, impianto e trasferta",
          "Foto o video di feste di paese reali, non solo serate in club",
        ],
      },
      {
        text: "Volete parlarne? Scrivetemi su WhatsApp: in pochi minuti capiamo insieme cosa serve alla vostra piazza. La festa del vostro paese merita di essere ricordata.",
      },
    ],
  },
  {
    slug: "canzoni-primo-ballo-matrimonio",
    title: "Canzoni per il Primo Ballo: Guida | DJMAGIX",
    description:
      "Come scegliere la canzone del primo ballo: i brani intramontabili, la durata giusta, i trucchi da DJ e gli effetti che rendono il momento unico.",
    h1: "La Musica per il Primo Ballo: Come Sceglierla (e Renderla Indimenticabile)",
    date: "2026-10-16",
    image: "/assets/gallery4.webp",
    excerpt:
      "La scelta della canzone, la durata giusta e il fade-out al momento perfetto: guida pratica al primo ballo, con i brani che funzionano sempre.",
    blocks: [
      {
        text: "È il momento più fotografato del matrimonio: voi due, soli in pista, e trecento occhi addosso. Dopo centinaia di primi balli visti dalla consolle, so che l'ansia da scelta blocca quasi tutte le coppie. Tranquilli: con qualche regola pratica la decisione diventa semplice.",
      },
      {
        h2: "1. La canzone giusta è la vostra",
        text: "Non cercate la classifica del momento. Cercate il brano che racconta voi: quello del primo appuntamento, del viaggio, della domenica sul divano. Se non avete una canzone, partiamo insieme da tre candidate e le ascoltiamo con calma. La scelta arriva quasi sempre da sola.",
      },
      {
        h2: "2. Due minuti bastano",
        text: "Nessuno vi obbliga a ballare un brano intero. Due, due minuti e mezzo sono perfetti: il momento resta intenso e gli ospiti non si distraggono. Qui entra il mio lavoro: preparo il brano con un'uscita morbida al punto giusto, o un edit su misura se serve. Voi pensate solo a ballare.",
      },
      {
        h2: "3. I brani che funzionano sempre",
        text: "Se siete in alto mare, questi non deludono mai:",
        list: [
          "Perfect e Thinking Out Loud — Ed Sheeran",
          "At Last — Etta James",
          "Can't Help Falling in Love — Elvis Presley",
          "La Cura — Franco Battiato",
          "A Modo Tuo — Elisa",
          "Il Mondo — Jimmy Fontana",
          "Shallow — Lady Gaga & Bradley Cooper",
        ],
      },
      {
        h2: "4. Gli effetti che fanno la differenza",
        text: "La stessa canzone, con la luce giusta, diventa un ricordo per tutta la vita. Per il primo ballo preparo luci calde e soffuse sulla pista e, dove la location lo permette, le fontane fredde: sicure, senza fumo né odore, e spettacolari nelle foto. Parlatene sempre prima con la villa o il ristorante.",
      },
      {
        h2: "5. Il momento giusto della serata",
        text: "Il primo ballo funziona meglio dopo il taglio della torta o subito dopo cena: gli ospiti sono attenti e l'energia è alta. Se volete, facciamo una prova rapida durante il sopralluogo: dieci minuti per sciogliere il ghiaccio e togliere ogni timore.",
      },
      {
        text: "Avete già la vostra canzone o siete indecisi tra tre? Scrivetemi su WhatsApp: la ascoltiamo insieme e prepariamo il momento esatto, nota per nota.",
      },
    ],
  },
  {
    slug: "scegliere-dj-matrimonio-ticino",
    title: "Come Scegliere il DJ per il Matrimonio in Ticino | DJMAGIX",
    description:
      "Guida alla scelta del DJ per il matrimonio in Ticino: esperienza, attrezzatura, repertorio e prezzo. I 6 controlli da fare prima di prenotare.",
    h1: "Come Scegliere il DJ per il Matrimonio in Ticino",
    date: "2026-10-16",
    image: "/assets/matrimonio2.webp",
    excerpt:
      "Esperienza, attrezzatura, repertorio e preventivo: i 6 controlli da fare prima di prenotare le nozze in Ticino.",
    blocks: [
      {
        text: "Il DJ può trasformare il vostro matrimonio in una festa indimenticabile — o in una serata con la pista vuota. Dopo 25 anni di matrimoni in Ticino, ecco i 6 controlli che consiglio di fare a ogni coppia prima di firmare.",
      },
      {
        h2: "1. Esperienza vera, non solo una playlist",
        text: "Un matrimonio non è una serata in club: ci sono nonni, bambini, amici e colleghi. Serve un DJ che sappia leggere la pista e passare dal lento al revival anni 80/90 senza perdere nessuno. Chiedete sempre quanti matrimoni ha seguito, non solo quante serate.",
      },
      {
        h2: "2. Attrezzatura propria e piano B",
        text: "Un professionista arriva con il proprio impianto audio e luci, microfoni wireless per discorsi e cerimonia, e un piano B in caso di guasto. Se la location deve noleggiare l'impianto separatamente, il costo finale sale e la responsabilità si frammenta.",
      },
      {
        h2: "3. Incontro conoscitivo e scaletta su misura",
        text: "Diffidate di chi non vi chiede nulla. Un buon DJ vuole sapere: i vostri brani del cuore, i generi da evitare, i momenti chiave (ingresso, primo ballo, taglio torta) e il profilo degli ospiti. La scaletta si costruisce insieme, settimane prima.",
      },
      {
        h2: "4. Preventivo chiaro e scritto",
        text: "Il preventivo deve indicare ore di servizio, attrezzatura inclusa, trasferta ed eventuali extra come fontane fredde o karaoke. Da DJ Magix il prezzo parte da CHF 150 e il preventivo è sempre gratuito e senza impegno.",
      },
      {
        h2: "5. Recensioni e video di eventi reali",
        text: "Foto e video di matrimoni veri valgono più di mille parole. Guardate i social del DJ, chiedete referenze e verificate che le recensioni parlino di matrimoni, non solo di serate in discoteca.",
      },
      {
        h2: "6. La chimica giusta",
        text: "Il DJ sarà la voce del vostro matrimonio: deve capirvi al volo e mettervi a vostro agio. Se al primo incontro — anche solo telefonico — la sintonia non scatta, cercate oltre. Volete parlarne? Scrivetemi su WhatsApp: vi rispondo personalmente.",
      },
    ],
  },
  {
    slug: "costo-dj-svizzera",
    title: "Quanto Costa un DJ in Svizzera? Prezzi 2026 | DJMAGIX",
    description:
      "Quanto costa un DJ per matrimonio o festa in Svizzera? Cosa influenza il prezzo, cosa deve includere il preventivo e come valutare le offerte.",
    h1: "Quanto Costa un DJ in Svizzera? Guida ai Prezzi",
    date: "2026-10-16",
    image: "/assets/gallery1.webp",
    excerpt:
      "Fasce di prezzo, cosa include un preventivo serio e i fattori che fanno salire (o scendere) il costo di un DJ in Svizzera.",
    blocks: [
      {
        text: "È la domanda che ricevo più spesso: quanto costa un DJ per un matrimonio o una festa? La risposta onesta è: dipende. In Svizzera i prezzi variano tipicamente da poche centinaia di franchi per una festa privata semplice a oltre mille per un matrimonio completo con effetti. Ecco come orientarsi.",
      },
      {
        h2: "Cosa influenza il prezzo",
        text: "Cinque fattori decidono il costo finale:",
        list: [
          "Durata del servizio: un aperitivo di 2 ore o una festa fino alle 4 di notte non costano uguali",
          "Trasferta: un evento in Ticino o uno a Zurigo o Ginevra comportano logistica diversa",
          "Attrezzatura: impianto per 50 ospiti in salotto o audio e luci per 1000 persone in piazza",
          "Effetti speciali: fontane fredde, laser show, karaoke professionale",
          "La data: i weekend tra maggio e settembre sono i più richiesti",
        ],
      },
      {
        h2: "Cosa deve includere un buon preventivo",
        text: "Ore di presenza, montaggio e smontaggio, impianto audio e luci, microfoni, incontro preparatorio e scaletta personalizzata. Se una voce manca, chiedete: gli extra scoperti all'ultimo sono la fonte principale di malintesi.",
      },
      {
        h2: "Il prezzo di DJ Magix",
        text: "I miei servizi partono da CHF 150, con preventivo gratuito, scritto e senza impegno. Attrezzatura audio e luci sempre inclusa, trasferte in Ticino e fino a 200 km (Zurigo, Ginevra, Berna, Basilea, Nord Italia). Raccontatemi il vostro evento dal modulo preventivo o su WhatsApp e riceverete una proposta su misura.",
      },
    ],
  },
  {
    slug: "migliori-canzoni-matrimonio",
    title: "Migliori Canzoni Matrimonio 2025: la Playlist | DJMAGIX",
    description:
      "Le migliori canzoni per il matrimonio: primo ballo, ingresso, aperitivo e festa anni 80/90. La playlist ideale secondo un DJ con 25 anni di piste.",
    h1: "Le Migliori Canzoni per il Matrimonio: la Playlist del DJ",
    date: "2026-10-16",
    image: "/assets/gallery5.webp",
    excerpt:
      "Primo ballo, ingresso trionfale, aperitivo elegante e festa scatenata: i brani che funzionano sempre, scelti da un DJ con 25 anni di matrimoni.",
    blocks: [
      {
        text: "Dopo centinaia di matrimoni so quali brani riempiono la pista e quali la svuotano. Ecco la mia selezione per i momenti chiave — usatela come base, poi la personalizziamo insieme con i vostri brani del cuore.",
      },
      {
        h2: "Il primo ballo",
        text: "Il momento più fotografato: scegliete un brano che racconta voi due, non quello che 'si usa'. Alcuni classici che non deludono mai:",
        list: [
          "Perfect — Ed Sheeran",
          "At Last — Etta James",
          "Thinking Out Loud — Ed Sheeran",
          "La cura — Franco Battiato",
          "Unchained Melody — The Righteous Brothers",
        ],
      },
      {
        h2: "Ingresso e momenti chiave",
        text: "L'ingresso degli sposi chiede energia immediata: 'Can't Stop the Feeling' di Justin Timberlake, 'Marry You' di Bruno Mars o 'Con te partirò' di Bocelli per un ingresso solenne. Per il taglio torta, con le fontane fredde, funziona tutto ciò che è epico e crescente.",
      },
      {
        h2: "Aperitivo: elegante ma non noioso",
        text: "Soul, jazz rivisitato e nu-disco a volume conversazione: Norah Jones, Michael Bublé, i classici Motown. L'aperitivo prepara l'atmosfera, non deve rubare la scena alla cena.",
      },
      {
        h2: "La festa: revival anni 80/90 e pista piena",
        text: "Qui si vince la serata: ABBA, Queen, i grandi anthem dance anni '90, poi disco dance e le hit di oggi. Il segreto è l'ordine: si parte trasversali per tutte le età e si alza il ritmo man mano che la notte avanza. Con la scaletta giusta, anche gli zii finiscono in pista.",
      },
    ],
  },
];
